<div class="dialog-box">
  <div class="subtitle">
    <span>Persquisar registro no CNES</span>
  </div>

  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Número do CNES</mat-label>
    <input matInput #code />
  </mat-form-field>
  <button mat-button (click)="findCnes(code.value)">Pesquisar</button>

  <button mat-button (click)="findCnes('123')">
    Aplicar os dados
  </button>
  <button mat-button (click)="dialogRef.close()">Cancelar</button>
</div>
{{ cnsFound }}